import { render } from "./DescriptionView.vue?vue&type=template&id=281e4886"
import script from "./DescriptionView.vue?vue&type=script&lang=js"
export * from "./DescriptionView.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__